import type { Media } from 'queries/graphql';

type ImgProps = {
  src: string;
  alt: string;
  width: number;
  height: number;
  placeholder?: 'blur';
  blurDataURL?: string;
};

export function buildImgProps(media: Media): ImgProps {
  if (!media) {
    // @lkuich - Add a placeholder missing image
    return {
      src: '',
      alt: '',
      width: 0,
      height: 0,
    };
  }

  const payload: ImgProps = {
    src: media.src,
    alt: media.alt,
    width: media.width,
    height: media.height,
  };

  if (media.blurDataUrl) {
    payload.placeholder = 'blur';
    payload.blurDataURL = media.blurDataUrl;
  }

  return payload;
}
